/*
  Native lazyloading on steroids using https://unlazy.byjohann.dev/
*/

import { lazyLoad } from 'unlazy'

lazyLoad('img[loading="lazy"]', {
  updateSizesOnResize: true,
  onImageLoad: function(image) {
    image.classList.add('loaded');
  }
});
